import { render, staticRenderFns } from "./PageNewRetireeTicket.vue?vue&type=template&id=552d6861&scoped=true&"
import script from "./PageNewRetireeTicket.vue?vue&type=script&lang=js&"
export * from "./PageNewRetireeTicket.vue?vue&type=script&lang=js&"
import style0 from "./PageNewRetireeTicket.vue?vue&type=style&index=0&id=552d6861&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "552d6861",
  null
  
)

export default component.exports